import { supabase } from '@/core/database/supabase';
import type { UserSalary, SalaryFilters } from '../types/salary.types';

export const SalaryService = {
  async getSalaries(companyId: string, filters: SalaryFilters = {}) {
    let query = supabase
      .from('user_salaries')
      .select('*, user_profiles(full_name, user_code, job_title)', { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.status === 'active') {
      query = query.is('effective_to', null);
    } else if (filters.status === 'archived') {
      query = query.not('effective_to', 'is', null);
    }
    
    if (filters.search) {
      query = query.not('user_profiles', 'is', null).or(`full_name.ilike.%${filters.search}%,user_code.ilike.%${filters.search}%`, { foreignTable: 'user_profiles' });
    }

    const { data, error, count } = await query.order('effective_from', { ascending: false });

    if (error) throw error;
    return { data: data as UserSalary[], total: count || 0 };
  },

  async getUserSalaries(userId: string): Promise<UserSalary[]> {
    const { data, error } = await supabase
      .from('user_salaries')
      .select('*')
      .eq('user_id', userId)
      .order('effective_from', { ascending: false });

    if (error) throw error;
    return data as UserSalary[];
  },

  async createSalary(salary: Partial<UserSalary>) {
    const { data, error } = await supabase
      .from('user_salaries')
      .insert(salary)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updateSalary(id: string, updates: Partial<UserSalary>) {
    const { data, error } = await supabase
      .from('user_salaries')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deleteSalary(id: string) {
    const { error } = await supabase
      .from('user_salaries')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
